import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=87c38ee4&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=87c38ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c38ee4",
  null
  
)

export default component.exports